/**
 * Reserved strip under macOS traffic lights.
 *
 * The parent `.titlebar` is `-webkit-app-region: drag`. Padding on that
 * element is still a drag surface, so the native red/yellow/green buttons
 * never receive clicks. This sibling is `no-drag` and sits in the lights'
 * hit target (`trafficLightPosition: { x: 10, y: 10 }` + `h-12`).
 */
export function MacTrafficLightSlot() {
  return (
    <div
      data-testid="titlebar-traffic-lights"
      className="titlebar-traffic-lights h-12 w-20 shrink-0"
      aria-hidden
    />
  );
}
